/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Type of containment action
 * @export
 */
export const ControlType = {
    DirectoryUser: 'directory_user',
    Endpoint: 'endpoint',
    File: 'file'
} as const;
export type ControlType = typeof ControlType[keyof typeof ControlType];


export function ControlTypeFromJSON(json: any): ControlType {
    return ControlTypeFromJSONTyped(json, false);
}

export function ControlTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlType {
    return json as ControlType;
}

export function ControlTypeToJSON(value?: ControlType | null): any {
    return value as any;
}

